<template>
    <footer class="row mt-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-md-10 text-center text-md-left">
					<div class="row">
						<div class="col-12 col-md-2">
							<img src="/assets/images/logo.png" class="bg-white" style="width: 100%">
						</div>
						<div class="col-12 col-md-10 text-center">
							<p><small><a href="/dieu-khoan">Điều khoản</a> | <a href="/bao-mat">Bảo mật</a></small></p>
							<p>CÔNG TY CỔ PHẦN TRAVELLET VIỆT NAM</p>						
							<p>
								<small>Hotline: 0842364935</small>
							</p>
							<p>
								<small>Email: biz@travellet.vn</small>
							</p>
							<p>
								<small>Thời gian: <strong style="color:#0062cc">8:00 - 22:00 Tất cả các ngày </strong>(GM+7)</small>
							</p>
							<p>
								<small>Chơi quá 180 phút một ngày sẽ ảnh hưởng xấu đến sức khỏe</small>
							</p>
							<p>
								<small>Quyết định phê duyệt nội dung kịch bản trò chơi điện tử G1 trên mạng số: 1876/QĐ-BTTTT ngày 04/11/2020</small>
							</p>
							<p>
								<small>Người chịu trách nhiệm nội dung : Ông Trần Minh Hảo</small>
							</p>
							<p>
								<small>Địa chỉ: Địa chỉ: 22 Hồng Hà, Phường 2, Quận Tân Bình, Hồ Chí Minh, Việt Nam</small>
							</p>
							
						</div>
					</div>
				</div>
				<div class="col-12 col-md-2 text-center text-md-right">
					<small>
						<img src="/assets/images/18plus.png" class="bg-white" style="width: 60px">
					</small>
				</div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "FooterComponent"
    }
</script>

<style scoped>

</style>
